<script>
import {
  notificationHeaderComputed,
  notificationHeaderMethods,
} from '@state/helpers/notification-header'
export default {
  props: {
    size: {
      type: String,
      default: 'lg',
      require: false,
    },
    backdropClose: {
      type: Boolean,
      require: false,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
      require: true,
    },
  },
  data() {
    return {
      openModal: false,
    }
  },
  computed: {
    ...notificationHeaderComputed,
    urlImageComputed() {
      if (this.getNotificationDetails?.image_url) {
        return `${process.env.VUE_APP_API_BASE_URL}/${this.getNotificationDetails.image_url}`
      }
      return ''
    },
    contentComputed() {
      if (this.getNotificationDetails?.content) {
        const rawHtml = this.getNotificationDetails.content.replaceAll(
          '\n',
          '<br />'
        )
        return rawHtml
      }
      return ''
    },
  },
  methods: {
    ...notificationHeaderMethods,
    handleCloseModal() {
      this.$emit('closeModal')
    },
  },
}
</script>

<template>
  <div>
    <CModal
      id="modal-notification-detail"
      v-bind="$attrs"
      :size="size"
      :close-on-backdrop="!backdropClose"
      centered
      v-on="$listeners"
    >
      <template v-slot:header>
        <CButtonClose
          class="notification-btn d-flex align-items-center justify-content-center p-1"
          @click="handleCloseModal"
          ><font-awesome-icon icon="times-circle"
        /></CButtonClose>
      </template>
      <slot name="body-notificcation" :item="item">
        <p>{{ item.schedule_start }}</p>
        <CImg
          v-show="item.image_url"
          :src="urlImageComputed"
          class="notification-detail-img"
        />
        <h4>{{ item.title }}</h4>
        <!-- eslint-disable vue/no-v-html -->
        <p v-html="contentComputed"></p>
      </slot>
      <template v-slot:footer-wrapper>
        <div></div>
      </template>
    </CModal>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .modal-content {
  left: 50%;
  width: 500px;
  transform: translateX(-50%);
}
::v-deep .modal-header {
  display: flex;
  justify-content: flex-end;
  background-color: $feelline-bg-primary;
}
.notification-detail-img {
  max-width: 450px;
  max-height: 350px;
}
.notification-btn {
  width: 30px;
  height: 30px;
}
::v-deep .svg-inline--fa.fa-w-16 {
  width: 15px;
}
</style>
